import React from 'react';
import moment from 'moment';
import featureFlags from '../../utils/featureFlags';

const SUBMISSION_TYPE = {
    oi: "Owner's Interest",
    ocp: 'Owners and Contractors Protective'
};

export default class ClearanceMatchCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: false
        };
    }

    /**
     * When user changes value of the checkbox
     */
    onChange() {
        this.setState({ isActive: !this.state.isActive });
    }

    render() {
        const {
            match,
            submission: candidate,
            onSubmit,
            person: { isUnderwriter },
            selectedAgency = {}
        } = this.props;
        const { type: candidateType } = candidate;
        const { submission, type = '' } = match;
        let { status } = match;
        status = String(status).toLowerCase();

        let btnCopy = 'Get updated quote';
        if (status === 'emailed') {
            btnCopy = 'Get quote';
        } else if (type !== candidateType) {
            btnCopy = `Get ${type.toUpperCase()} quote`;
        }
        const matchTitle = SUBMISSION_TYPE[type] || 'Submission';
        const highlightBrokerAgency = !!(isUnderwriter && submission.broker.agency_code != selectedAgency.agencyCode)

        return (
            <div className={'card mb-x2' + (this.state.isActive ? ' card-primary active' : '')}>
                <section className="container-fluid pt-x2 pb-x2 pr-x2 pl-x2">
                    <div className="row">
                        <div className="col-xs-12 mb">
                            <h4 className="mn">
                                <span>{matchTitle}</span>
                                {status === 'emailed' && (
                                    <span className="label label-primary text-uppercase ml">
                                        Emailed Submission
                                    </span>
                                )}
                                {status === 'pending' && (
                                    <span className="label label-warning text-uppercase ml">
                                        Pending clearance
                                    </span>
                                )}
                                {status === 'quote' && (
                                    <span className="label label-success text-uppercase ml">
                                        Priced
                                    </span>
                                )}
                                {status === 'referral' && (
                                    <span className="label label-success text-uppercase ml">
                                        Referred
                                    </span>
                                )}
                                {highlightBrokerAgency && (
                                    <span
                                        className="label label-danger text-uppercase ml"
                                        style={{ backgroundColor: '#F44336' }}
                                    >
                                        Different Brokerage Office
                                        </span>
                                )}
                            </h4>
                        </div>
                        <div className="col-xs-12 col-md-6">
                            <address>
                                <small className="text-muted">First Name Insured</small>
                                <br />
                                {submission.named_insured.insured_name}
                                <br />
                                {submission.named_insured.address.street_line_1} <br />
                                {submission.named_insured.address.city}{' '}
                                {submission.named_insured.address.state}{' '}
                                {submission.named_insured.address.zip}
                                <br />
                            </address>
                            <address>
                                <small className="text-muted">Project Address</small>
                                <br />
                                {submission.project_address.street_line_1}
                                <br />
                                {submission.project_address.city} {submission.project_address.state}{' '}
                                {submission.project_address.zip}
                                <br />
                            </address>
                        </div>
                        <div className="col-xs-12 col-md-6 card-box">
                            <small className="text-muted">Broker</small>
                            <p
                                className={
                                    highlightBrokerAgency
                                        ? 'text-danger'
                                        : ''
                                }
                            >
                                {submission.broker.brokerage} <br />
                                {submission.broker.email}
                            </p>

                            <p className="text-muted">
                                {moment(match.submission_insert_timestamp).format('D/MM/YYYY')}{' '}
                                submitted <br />
                                {!!match.number && `#${match.number}`}
                            </p>
                        </div>
                    </div>
                    <div className="row mt">
                        <div className="col-xs-12">
                            <form
                                onSubmit={e => {
                                    e.preventDefault();
                                    onSubmit(match);
                                }}
                            >
                                <h4>Is this your project?</h4>
                                {status === 'emailed' && (
                                    <p>
                                        This submission has been emailed to Argo underwriters. Click
                                        below to quote it yourself.
                                    </p>
                                )}
                                <div className="checkbox">
                                    <label style={{ lineHeight: 1.4 }}>
                                        <input
                                            type="checkbox"
                                            onChange={this.onChange.bind(this)}
                                        />{' '}
                                        Yes, this is the same submission (match)
                                    </label>
                                </div>

                                <button className="btn btn-default" disabled={!this.state.isActive}>
                                    {btnCopy}
                                </button>
                            </form>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
